












































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IDomain } from "@/models/domains";
import i18n from "@/i18n";

@Component
export default class DomainsGridItem extends Vue {
  // Props

  @Prop({ default: undefined })
  public domain!: IDomain;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: i18n.t("_action.manage_domain") })
  public actionLabel!: string;

  @Prop({ default: undefined })
  public actionIcon!: string;

  @Prop({ default: false })
  public canDeleteDomain!: boolean;

  @Prop({ default: false })
  public canUnrevokeDomain!: boolean;

  @Prop({ default: false })
  public canRevokeDomain!: boolean;

  @Prop({ default: false })
  public canMakeDomainDefault!: boolean;

  @Prop({ default: false })
  public canVerifyDomain!: boolean;

  @Prop({ default: false })
  public canManageDomain!: boolean;

  // Computed

  /**
   * @name isPointable
   * @desc A domain is only considered pointable if it's been enabled for either
   * client or admin logins. Otherwise its inclusion should be predominantly for
   * trust reasons – such as widget inclusion.
   */

  public get isPointable() {
    return this.domain.staff_enabled || this.domain.customer_enabled;
  }

  public get isUnverified() {
    if (!this.isPointable) return false;
    return !this.domain.verified;
  }

  public get showDropdown() {
    return (
      this.canDeleteDomain ||
      this.canUnrevokeDomain ||
      this.canRevokeDomain ||
      this.canMakeDomainDefault ||
      this.canVerifyDomain ||
      this.canManageDomain
    );
  }
}
